module.exports = __webpack_public_path__ + "static/media/laptop-3196481__340.75b877c6.jpg";